export default function maxSpinAfterNext(rows, spin) {
  switch (rows) {
    case 8:
      return spin > 6 ? 6 : spin;
    case 9:
      return spin > 6 ? 6 : spin;
    case 10:
      if (spin > 5.5) return 5.5;
      if (spin < 2.5) return 2.5;
      return spin;
    case 11:
      if (spin > 5) return 5;
      if (spin < 2.5) return 2.5;
      return spin;
    case 12:
      if (spin > 5) return 5;
      if (spin < 2.5) return 2.5;
      return spin;
    case 13:
      if (spin > 5) return 5;
      if (spin < 2.5) return 2.5;
      return spin;
    case 14:
      if (spin > 4) return 4;
      if (spin < 2.2) return 2.2;
      return spin;

    case 15:
      if (spin > 3.5) return 3.5;
      if (spin < 2.2) return 2.2;
      return spin;
    case 16:
      if (spin > 3.5) return 3.5;
      if (spin < 2.2) return 2.2;
      return spin;
    default:
      break;
  }
}
